// Centralized menu configuration - can be moved to a separate file
const MENU_CONFIG = {
	role: {
		title: "User Role Editor",
		icon: "role.svg",
		activeIcon: "role-active.svg",
		description: "Edit User Roles From Here",
		items: [
			{
				id: "edit-role",
				label: "Edit Role Capabilities",
				path: "/edit-role",
				items: [],
			},
			{
				id: "role-manager",
				label: "Role Manager",
				path: "/role-manager",
				items: [],
			},
			{
				id: "backup-and-restore-role",
				label: "Backup & Restore Role",
				path: "/backup-and-restore-role",
				items: [],
			},
		],
		footer: {
			title: "Ready to Get Started?",
			description: "Take your docs to the next level of Metronic",
			button: "Read",
			action: "/documentation",
		},
	},
	global: {
		title: "Global Settings",
		icon: "global.svg",
		activeIcon: "global-active.svg",
		description: "Manage All Your Global Settings From Here",
		items: [
			{
				id: "settings",
				label: "Settings",
				path: "/settings",
				items: [],
			},
			{
				id: "color-customizer",
				label: "Color Customizer",
				path: "/color-customizer",
				items: [],
			},
			{
				id: "permission",
				label: "Permission",
				path: "/permission",
				// items: [
				//   {
				//     id: "roles",
				//     label: "Roles",
				//     path: "/permission/roles",
				//     items: [
				//       {
				//         id: "admin",
				//         label: "Admin Roles",
				//         path: "/permission/roles/admin",
				//         items: []
				//       },
				//       {
				//         id: "editor",
				//         label: "Editor Roles",
				//         path: "/permission/roles/editor",
				//         items: []
				//       }
				//     ]
				//   },
				//   {
				//     id: "capabilities",
				//     label: "Capabilities",
				//     path: "/permission/capabilities",
				//     items: []
				//   }
				// ]
			},
		],
		footer: {
			title: "Ready to Get Started?",
			description: "Take your docs to the next level of Metronic",
			button: "Read",
			action: "/documentation",
		},
	},

	more: {
		title: "More",
		icon: "more.svg",
		activeIcon: "more-active.svg",
		description: "Explore extra features of our plugin.",
		items: [
			{
				id: "reset",
				label: "Reset",
				path: "/reset",
				items: [],
			},
			{
				id: "extra",
				label: "Extra",
				path: "/extra",
				items: [],
			},
		],
		footer: {
			title: "Need More Options?",
			description: "Discover additional features and tools",
			button: "Read",
			action: "/features",
		},
	},
};

export default MENU_CONFIG;
